module.exports = __webpack_public_path__ + "static/media/Events.483ea2cd.less";